/* eslint-disable require-jsdoc */
import {callLambda} from '@/lib/api/lambda';

/**
 * 取得直播課程紀錄
 * @param {String} liveCourseUnitId liveCourseUnitId
 * @returns {Promise} promise
 */
async function getLiveCoursesRecord(liveCourseUnitId) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'recordUrl',
    params: {liveCourseUnitId},
  });
  const urls = res.data;
  if (Array.isArray(res.data)) {
    return urls[0];
  }
  return urls;
}

/**
 * 取得標籤直播課程
 * @param {Object} params 篩選資料
 * @returns {Promise} promise
 */
async function getLiveCoursesByTags(params) {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'units/vip',
    params,
  });
  return res.data;
}

/**
 * 取得老師非官方直播課程
 * @param {Object} params 篩選資料
 * @returns {Promise} promise
 */
async function getTeacherNormalLiveCourseList(params) {
  const {
    limit,
    isAscending,
    lastId,
    startAt,
    endAt,
    keyword,
    language = 'zh-TW',
  } = params;
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'units/teacher',
    params: {
      startAt,
      endAt,
      limit,
      isAscending,
      lastId,
      keyword,
      language,
    },
  });
  return res.data;
}

async function getStudentNormalLiveCourseList(params) {
  const {limit, isAscending, lastEndAt, lastId, startAt, endAt, language} =
    params;
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'units/users',
    params: {
      limit,
      isAscending,
      lastEndAt,
      lastId,
      startAt,
      endAt,
      language,
    },
  });
  return res.data;
}

/**
 *
 * @param {String} liveCourseUnitId 班級id
 * @param {String} timestamp 時間
 * @returns {Promise} promise
 */
function postLiveCourseRecord(liveCourseUnitId, timestamp) {
  return callLambda({
    category: 'liveCourse',
    method: 'POST',
    apiName: 'learningProcess',
    data: {
      liveCourseUnitId,
      timestamp,
    },
  }).then((res) => {
    return res;
  });
}

const getLiveCourseUnitCardCount = async () => {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'liveCourseUnitCard/count',
  });
  return res.data?.count || 0;
};

const getLiveCourse = async ({liveCourseId}) => {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: `/${liveCourseId}`,
  });
  return res.data;
};

const getLiveCourses = async ({startedAt, endedAt, language}) => {
  const params = {};
  if (startedAt) params.startedAt = startedAt;
  if (endedAt) params.endedAt = endedAt;
  if (language) params.language = language;
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: '',
    params,
  });
  return res.data;
};

const getLiveCourseUnits = async ({liveCourseId}) => {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: `${liveCourseId}/units`,
  });
  const unit = res.data;
  return unit;
};

const getLiveCourseUnit = async ({liveCourseId, liveCourseUnitId}) => {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: `${liveCourseId}/units/${liveCourseUnitId}`,
    params: {
      withDetail: true,
    },
  });
  const unit = res.data;
  return unit;
};

const redeemLiveCourseUnit = async ({liveCourseUnitId}) => {
  const res = await callLambda({
    category: 'liveCourse',
    method: 'GET',
    apiName: 'liveCourseUnitCard/redeem',
    params: {
      liveCourseUnitIds: liveCourseUnitId,
    },
  });
  const unit = res.data;
  return unit;
};

export default {
  getLiveCoursesByTags,
  getTeacherNormalLiveCourseList,
  getStudentNormalLiveCourseList,

  getLiveCoursesRecord,
  postLiveCourseRecord,
  getLiveCourseUnitCardCount,
  getLiveCourse,
  getLiveCourses,
  getLiveCourseUnit,
  getLiveCourseUnits,
  redeemLiveCourseUnit,
};
